export const COLORS = {
  EXERCISE : '#F55F15',
  EXERCISE_ALT: '#FF9900',
  FRUITS_AND_VEGGIES : '#FEBE3E',
  MAMMOGRAM: '#1095B0',
  MINDFULNESS: '#FF8500',
  SELF_CHECK: '#0DB39E',
  SLEEP: '#49D07F',
  WATER: '#FF9900',


  REDEEM: '#0DB39E',
  LIGHT_GRAY: '#EBEBEB',
  LIGHT_GRAY_FILL: 'EBEBEB',

  NAVY_BLUE: '#0B1E48',
}
